/* -----------------Globals--------------- */
import { pageViewTypes } from "@constants/tracking";

/* -----------------Child components--------------- */
import SessionContainer from "@features/session/screens/Session";

/* -----------------Helpers & Hooks--------------- */
import useAnalytics from "@hooks/useAnalytics";
import DocumentTitle from "components/DocumentTitle";

/* -----------------UI--------------- */
import { Stack } from "expo-router";
import { useMemo } from "react";

const ReviewRoute = () => {
	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.review,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<DocumentTitle title={"Review"} />
			<SessionContainer />
		</>
	);
};

export default ReviewRoute;
